<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Admissions: MBA"
                   :links="[{title:'Home', url:'/'},{title:'MBA'}]"></page-header>
      <div class="container-2 gap-4">
        <section class="content">
          <accordion :activeIndex="0">
            <accordion-tab header="Sanction Intake">
              <sanction-intake class="w-full" :programmes="programmes"></sanction-intake>
            </accordion-tab>
            <accordion-tab header="Important Notifications"></accordion-tab>
            <accordion-tab header="Eligibility Criteria"></accordion-tab>
            <accordion-tab header="Documents Required"></accordion-tab>
            <accordion-tab header="Admission Process"></accordion-tab>
          </accordion>
        </section>
        <div class="sidebar order-2">
          <div class="flex flex-col gap-3">
            <admission-contact-card v-for="(admissionContact,index) in admissionContacts" :key="index"
                                    :admissionContact="admissionContact"></admission-contact-card>
          </div>
        </div>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>

<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import KeyRecruiters from "@/components/KeyRecruiters";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import SanctionIntake from "@/views/admissions/SanctionIntake";
import AdmissionContactCard from "@/components/AdmissionContactCard";

export default {
  name: "Mba",
  components: {
    NavbarComponent,
    PageHeader,
    FooterComponent,
    KeyRecruiters,
    Accordion,
    AccordionTab,
    SanctionIntake,
    AdmissionContactCard
  },
  data() {
    return {
      programmes: [
        {
          name: 'MBA (All Specializations)',
          intake: 60,
          choiceCode: 512410110
        }
      ],
      admissionContacts: [{
        name: 'Prof. Samudre V. B.',
        designation: 'Admission Coordinator',
        mobile: '9975753396',
        email: 'vishal.sam1243@gmail.com'
      },
      ]
    }
  }
}
</script>

<style scoped>

</style>